import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import {
  deleteApi,
  getAPIWithoutToken,
  getApi,
  patchFileApi,
  postApi,
  postFileApi,
} from "lib";
import { CART, CREATE_ORDER, ORDERS ,SAVE_PAYMENT,INITIAL_PAYMENT,PREORDERTAX} from "services";
import { API_ERROR } from "utils/constant";

export const getCart = createAsyncThunk(
  "orders/getCart",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(CART);
      if (response?.data?.success) {
        if (!response?.data?.data?.cart_items?.length) {
          payload?.next();
        }
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);



export const preorderTax = createAsyncThunk(
  "orders/preorderTax",
  async (taxType, thunkAPI) => {
    try {
      const taxTypeQuery = taxType
        ? `?tax_type=${encodeURIComponent(taxType)}`
        : "";
      const response = await getApi(PREORDERTAX + taxTypeQuery);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);




export const postCart = createAsyncThunk(
  "orders/postCart",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postApi(CART, body);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const deleteCart = createAsyncThunk(
  "orders/deleteCart",
  async ({ id, next }, thunkAPI) => {
    try {
      const response = await deleteApi(CART + "?item_id=" + id);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message || "Package remove from Cart!");
      }
      return response?.data?.data;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);



export const initialpayment = createAsyncThunk(
  "orders/initialpayment",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postApi(INITIAL_PAYMENT, body);
      if (response?.data?.success) {
        next(response?.data?.data);
        message.success(response?.data?.message);
        return response
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const save_payment = createAsyncThunk(
  "orders/save_payment",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postApi(SAVE_PAYMENT, body);
      if (response?.data?.success) {
        next(response?.data?.data);
        // message.success(response?.data?.message);
        return response
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);













export const postOrder = createAsyncThunk(
  "orders/postOrder",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postFileApi(CREATE_ORDER, body);
      if (response?.data?.success) {
        next(response?.data?.data);
        message.success(response?.data?.message);
        return response?.data?.data?.id;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const patchOrder = createAsyncThunk(
  "orders/patchOrder",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await patchFileApi(CREATE_ORDER, body);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getOrders = createAsyncThunk(
  "orders/getOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        ORDERS + "?user_role=customer&sort_by=" + payload
      );
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getActiveOrders = createAsyncThunk(
  "orders/getActiveOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        ORDERS +
          `?user_role=healon&sort_by=scheduled&page=${
            payload?.page || 1
          }&items_per_page=10`
      );
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getCompletedOrders = createAsyncThunk(
  "orders/getCompletedOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        ORDERS +
          `?user_role=healon&sort_by=completed&page=${
            payload?.page || 1
          }&items_per_page=10`
      );
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getCancelledOrders = createAsyncThunk(
  "orders/getCancelledOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        ORDERS +
          `?user_role=healon&sort_by=cancelled&page=${
            payload?.page || 1
          }&items_per_page=10`
      );
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getOrderById = createAsyncThunk(
  "orders/getOrderById",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(CREATE_ORDER + "?order_id=" + payload);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
